// Generated from the approved MagicPath revision 440525496049094656. Do not hand-edit; update the source worktree instead.
import { useState } from 'react';
const oceanPlate = "/assets/page03-other-stuff.jpg";
const navigation = ['METHOD', 'HOUSE 45', 'INSIGHTS', 'ASSESSMENT'];
export const Page03WhyTheOtherStuffDidnTWork = () => {
  const [activeNav, setActiveNav] = useState('ASSESSMENT');
  return <main className="other2-page">
    <img className="other2-photo" src={oceanPlate} alt="A man standing waist-deep in a dark ocean, facing the horizon" />
    <div className="other2-grade" aria-hidden="true" />
    <button className="other2-wordmark" type="button" aria-label="IMTHEHOUSE home">IMTHEHOUSE</button>
    <nav className="other2-navigation" aria-label="Primary navigation">
      {navigation.map(item => <button type="button" key={item} className={activeNav === item ? 'active' : ''} onClick={() => setActiveNav(item)} aria-pressed={activeNav === item}>{item}</button>)}
    </nav>
    <section className="other2-copy" aria-labelledby="other2-heading">
      <p className="other2-eyebrow">WHY THE OTHER STUFF DIDN'T WORK</p>
      <span className="other2-rule" aria-hidden="true" />
      <h1 id="other2-heading">YOU DO NOT NEED A CAGE.<br /><span>YOU NEED COMMAND.</span></h1>
      <div className="other2-body">
        <p>You do not need to be softened, stripped of ambition, or removed from the life you built.</p>
        <p>You need to stop letting the most powerful part of you operate without rules.</p>
        <p>You can command a company, carry a family, and perform under pressure—then hand your mind to Sunday. That contradiction is the problem.</p>
        <p>Tell the truth. Close the exits. Put money under rules. Train the mind. Redirect the force.</p>
      </div>
    </section>
    <aside className="other2-close" aria-label="The goal">
      <p>THE GOAL IS NOT TO<br />MAKE YOU HARMLESS.</p>
      <strong>IT IS TO MAKE<br />YOU RELIABLE.</strong>
    </aside>
    <div className="other2-scene" aria-label="Scene 3 of 11"><strong>03</strong><i>/</i><span>11</span></div>
  </main>;
};